import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'lokos-input',
    templateUrl: './input.component.html',
    styleUrl: './input.component.scss',
    standalone: false,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputComponent),
            multi: true,
        },
    ],
})
export class InputComponent implements ControlValueAccessor {
    @Input() type = 'text';
    @Input() placeholder = '';
    @Input() label = '';
    @Input() iconLeft = '';
    @Input() disabled = false;

    @Output() valueChange = new EventEmitter<string>();

    value = '';
    private onChange: (value: string) => void = () => undefined;
    private onTouched: () => void = () => undefined;

    writeValue(value: string): void {
        this.value = value || '';
    }

    registerOnChange(fn: (value: string) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    onInput(event: Event) {
        const target = event.target as HTMLInputElement;
        this.value = target.value;
        this.onChange(this.value);
        this.valueChange.emit(this.value);
    }

    onBlur() {
        this.onTouched();
    }
}
